import BaseAPI from "@/apis/base/base-api";
import httpClient from "@/apis/base/axios-httpclient";

class CustomerAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "CorePayment";
  controllerName = "customer";

  /**
   * @override: Lấy dữ liệu danh sách
   */
  // getList(payload) {
  //     // URL mặc định
  //     console.log(payload);
  //     let url = this.getAPIUrl() + '/all';
  //     // Build tham số
  //     let request = {
  //         url: url,
  //         // data: payload
  //     };

  //     // Call api
  //     return httpClient.getAsync(request);
  // }

  /**
   * Lấy dữ liệu danh sách
   */
  //   getList(payload) {
  //       var param = {
  //         SkipCount: payload.SkipCount,
  //         MaxResultCount: payload.MaxResultCount,
  //         Filter: payload.filter || ''
  //       };
  //     let request = {
  //         url: this.getAPIUrl() + "/list",
  //         data: param
  //     };

  //     return httpClient.postAsync(request);
  // }

  /**
   * Lấy bản ghi mặc định khi thêm mới
   */
  getNew(payload) {
    return;
  }

  /**
   * Thêm mới
   */
  insert(payload) {
    let request = {
      url: this.getAPIUrl(),
      data: payload.Entity,
    };
    return httpClient.postAsync(request, true);
  }

  /**
   * Xóa
   */
  delete(payload) {
    let request = {
      url: this.getAPIUrl() + "/" + payload.Entity[0].id,
      data: payload,
    };
    return httpClient.deleteAsync(request, true);
  }
}

export default new CustomerAPI();
